import React from "react";

// Compartido entre LicitacionDetail.jsx y Delegado.jsx. Iter243.
export function ComposicionOferta({ kpi }) {
  const tec = kpi?.criterio_tecnico_automatico_pct;
  const jv = kpi?.criterio_juicio_valor_pct;
  const eco = kpi?.criterio_economico_pct;
  if (tec == null && jv == null && eco == null) {
    return <p className="text-xs text-gray-400">Sin criterios de valoración identificados todavía.</p>;
  }
  const parts = [
    { label: "Técnico automático", v: tec || 0, cls: "bg-sky-500" },
    { label: "Juicio de valor", v: jv || 0, cls: "bg-violet-500" },
    { label: "Económico", v: eco || 0, cls: "bg-emerald-500" },
  ].filter(p => p.v > 0);
  return (
    <div data-testid="resumen-composicion-oferta">
      <div className="flex h-5 w-full rounded-full overflow-hidden border border-gray-200">
        {parts.map(p => (
          <div key={p.label} className={`${p.cls} flex items-center justify-center text-[9px] text-white font-semibold`} style={{ width: `${p.v}%` }} title={`${p.label}: ${p.v}%`}>
            {p.v >= 12 ? `${p.v}%` : ""}
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-3 mt-2">
        {parts.map(p => (
          <span key={p.label} className="text-[11px] text-gray-600 flex items-center gap-1">
            <span className={`w-2 h-2 rounded-full ${p.cls}`} /> {p.label} <b>{p.v}%</b>
          </span>
        ))}
      </div>
    </div>
  );
}

export default ComposicionOferta;
